// Pure free-text filter + single-field sort for the hallinta lists, applied by
// the shared EntityList component (People / Vehicles / Sijainnit tabs).
// Kept dependency-free so it is unit-testable in isolation.

function matchesSearch(row, searchKeys, needle) {
  return searchKeys.some((k) => String(row[k] ?? "").toLowerCase().includes(needle));
}

// Compare two cell values: empty/null first, numeric-aware (so "2" < "10"),
// otherwise Finnish locale, case-insensitive.
function compareValues(a, b) {
  const aEmpty = a == null || a === "";
  const bEmpty = b == null || b === "";
  if (aEmpty && bEmpty) return 0;
  if (aEmpty) return -1;
  if (bEmpty) return 1;
  const an = Number(a);
  const bn = Number(b);
  if (Number.isFinite(an) && Number.isFinite(bn)) return an - bn;
  return String(a).localeCompare(String(b), "fi", { sensitivity: "base" });
}

// rows: array of row objects (or null/undefined while loading → returned as-is).
// search: free-text needle; searchKeys: row keys it matches against.
// sortKey: "" means keep incoming order; sortDir: "asc" | "desc".
export function filterAndSortRows(rows, { search = "", searchKeys = [], sortKey = "", sortDir = "asc" } = {}) {
  if (!Array.isArray(rows)) return rows;
  let out = rows;
  const needle = search.trim().toLowerCase();
  if (needle && searchKeys.length) out = out.filter((r) => matchesSearch(r, searchKeys, needle));
  if (sortKey) {
    const dir = sortDir === "desc" ? -1 : 1;
    out = [...out].sort((a, b) => dir * compareValues(a[sortKey], b[sortKey]));
  }
  return out;
}
